import { delay } from "../../../../utils/utils";
import { AbortRequestEventBus } from "../../../event-bus";
import { DirtyState } from "../dirty-state";

export async function waitUntilCleanState(dirtyState: DirtyState) {
  let cleanStateTimeoutReached = false;
  let stopLoop = false;

  const abortHandler = () => {
    stopLoop = true;
  };
  AbortRequestEventBus.on("abort", abortHandler);

  const timeout = setTimeout(() => {
    cleanStateTimeoutReached = true;
  }, 30 * 1000);

  while (dirtyState.isDirty() && !stopLoop && !cleanStateTimeoutReached) {
    await delay(20);
  }

  if (timeout) clearTimeout(timeout);

  AbortRequestEventBus.off("abort", abortHandler);

  if (cleanStateTimeoutReached) {
    throw "Waiting for clean state timed out.";
  } else if (stopLoop) {
    throw "Loading got aborted.";
  }
}
